import { styled } from "styled-components";

export const PricingSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 99px 0;
  align-items: center;
  background-color: ${(props) => props.theme.colors.default[50]};
`;

export const PricingSectionHeader = styled.div`
  padding: 0 24px 24px 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  text-align: center;
`;

export const PricingSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;
  max-width: ${({ theme }) => theme.content.maxWidth}px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.md.query} {
    gap: 36px;
    padding: 0 16px;
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    gap: 24px;
    padding: 0 0px;
  }
`;

export const PricingCardWrapper = styled.div`
  width: 100%;
  overflow: visible;
  scrollbar-width: none;
  position: relative;
`;

export const PricingCardContainer = styled.div`
  display: flex;
  width: ${({ theme }) => theme.content.maxWidth}px;
  gap: 12px;
  overflow: visible;

  /* Tablet support */
  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    max-width: 100%;
    align-items: center;
    padding: 0 16px;
  }
`;

export const MostPopularWrapper = styled.div<{ $isMobile: boolean }>`
  position: absolute;
  top: 0;
  left: ${({ $isMobile }) => ($isMobile ? "65%" : "50%")};
  transform: translate(-50%, -80%);
  z-index: 10;
  display: ${({ $isMobile }) => ($isMobile ? "none" : "initial")};
  width: 200px;
  pointer-events: none;
`;

export const CarouselRow = styled.div`
  display: flex;
  gap: 12px;
  position: relative;
  overflow: visible;

  /* Mobile-first: base styles for small devices */
  ${({ theme }) => theme.breakpoints.md.query} {
    overflow-x: auto;
    overflow-y: visible;
    -webkit-overflow-scrolling: touch;
    scroll-behavior: smooth;
    flex-wrap: nowrap;
    width: 100%;
    padding: 35px 0 1rem 0;
  }

  ${({ theme }) => theme.breakpoints.sm.query} {
    gap: 24px;
  }

  ${({ theme }) => theme.breakpoints.xs.query} {
    gap: 70px;
  }
`;

export const CarouselItem = styled.div`
  position: relative;
  display: inline-block;
  overflow: visible;

  /* Tablet (iPad landscape) */
  ${({ theme }) => theme.breakpoints.md.query} {
    flex: 0 0 80%;
    min-width: 80%;
    max-width: 80%;
    margin-left: 5px;
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  padding: 0 24px;
  color: ${({ theme }) => theme.colors.default[500]};

  ${({ theme }) => theme.breakpoints.md.query} {
    padding: 0 16px;
    text-align: center;
  }
`;
